import React from 'react'

const Error = () => (
  <section className="hero is-fullheight is-warning">
    <div className="hero-body">
      <div className="container">
        <p className="title is-1 has-text-centered has-text-white">
          Something went wrong!
          Don&apos;t let the muggles get you down.
        </p>
      </div>
    </div>
  </section>
)

export default Error